export default "assets/images/noise-d2ef36c2.png";